
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import SpacesListView from "./spaces-list.html";

angular.module("spaces", ['ui.bootstrap.contextMenu'])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('spaces', {
                url: "/spaces",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('spaces.list', {
                url: "/list",
                controller: "SpacesListCtrl",
                template: SpacesListView
            })           
    }])
;